import { FadeUp } from "@/components/Reveal";

export const Welcome = () => {
  return (
    <section id="welcome" data-testid="welcome-section" className="section-pad relative">
      <div className="max-w-[1100px] mx-auto grid md:grid-cols-12 gap-12 md:gap-16 items-start">
        <FadeUp className="md:col-span-4">
          <div className="eyebrow-line">A Note from the Host</div>
          <h2
            className="font-serif-display text-[#FDFBF7] mt-6 leading-[1.05]"
            style={{ fontSize: "clamp(36px, 5vw, 56px)" }}
          >
            An evening,{" "}
            <span className="italic text-[#D4AF37]">in rotation.</span>
          </h2>
        </FadeUp>

        <FadeUp delay={0.15} className="md:col-span-8">
          <p className="text-[#FDFBF7]/85 text-lg md:text-xl leading-[1.7] font-light max-w-[60ch]">
            Hi — I'm{" "}
            <span className="text-[#D4AF37] font-serif-display italic">
              Larry
            </span>
            , your host.
          </p>

          <p className="text-[#FDFBF7]/85 text-base md:text-lg leading-[1.8] font-light max-w-[60ch] mt-6">
            <span className="font-serif-display italic text-[#D4AF37]">
              33 RPM
            </span>{" "}
            has two meanings to me. It's the speed at which a vinyl record turns
            — the way an album is meant to be played, start to finish, side A
            to side B. And this June, it's the age I become.
          </p>

          <p className="text-[#FDFBF7]/85 text-base md:text-lg leading-[1.8] font-light max-w-[60ch] mt-5">
            So this dinner is both — a record played at its true speed, and a
            quiet celebration of arriving here. A handful of people I care
            about, one shared table, a vinyl needle drop, and a soundtrack
            written by the room itself.
          </p>

          <div className="divider-gold my-10" />

          <p className="text-[#A3A3A3] text-base md:text-lg leading-[1.8] max-w-[58ch]">
            I believe in slow service, deep listening, and the small rituals of
            hospitality — the polish of a coupe glass, the warmth of walnut
            under candlelight, the patience of a record that asks to be heard
            from start to finish. You are not attending a restaurant. You are
            joining a room.
          </p>

          {/* Vibe summary */}
          <div className="mt-12 border-l-2 border-[#D4AF37] pl-6 max-w-[58ch]">
            <div className="overline">The Night, In Brief</div>
            <p className="font-serif-display italic text-[#FDFBF7] mt-3 text-xl md:text-2xl leading-[1.5]">
              Candlelight and walnut. Dinner catered by{" "}
              <span className="text-[#D4AF37]">Aba</span> in the West Loop and
              served at the table by a private waiter. Cocktails poured by a
              bartender for the room, and records — yours — playing the whole
              way through.
            </p>
            <p className="text-[#A3A3A3] text-sm mt-5 tracking-wide">
              — Larry
            </p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};
